/* Aanvraagvelden: het versturen met foto.

   Het thema stuurt "in winkelwagen" via theme.utils.serialize, en die functie
   slaat velden van het type file over en post urlencoded. Een foto zou daar
   dus stilzwijgend uit vallen. Daarom nemen we het versturen over voor de
   producten "op aanvraag": we luisteren in de capture-fase op document, zodat
   we gegarandeerd eerder aan de beurt zijn dan de listener die het thema op
   het formulier zelf zet, en versturen met FormData.

   Alleen deze formulieren worden overgenomen; alle andere producten blijven
   het gewone pad van het thema volgen. */
(function () {
  'use strict';

  if (window.__lfAanvraagGestart) { return; }
  window.__lfAanvraagGestart = true;

  /* De server geeft boven 20 MB een kale 413-pagina terug. We houden het
     bestand zelf tegen met marge, zodat de klant een leesbare melding krijgt
     in plaats van een foutpagina. */
  var MAX_BYTES = 19 * 1024 * 1024;

  function blokVan(form) {
    /* Het blok staat binnen het formulier, maar de velden kunnen er via het
       form-attribuut ook buiten hangen. Zoek daarom beide kanten op. */
    var blok = form.querySelector('[data-lf-aanvraag-blok]');
    if (blok) { return blok; }
    var veld = form.elements ? form.elements['properties[Voorbeeldfoto]'] : null;
    return veld ? veld.closest('[data-lf-aanvraag-blok]') : null;
  }

  function toonFout(blok, tekst) {
    var vak = blok ? blok.querySelector('[data-lf-aanvraag-fout]') : null;
    if (!vak) { window.alert(tekst); return; }
    vak.textContent = tekst;
    vak.hidden = false;
  }

  function wisFout(blok) {
    var vak = blok ? blok.querySelector('[data-lf-aanvraag-fout]') : null;
    if (vak) { vak.hidden = true; }
  }

  /* De teksten komen uit de vertaalbestanden en staan als data-attribuut op
     het blok; zo hoeft theme.liquid er niet voor aangepast te worden. */
  function tekstVan(blok, naam, terugval) {
    var t = blok ? blok.getAttribute('data-lf-tekst-' + naam) : null;
    return t || terugval;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) { return; }

    var blok = blokVan(form);
    if (!blok) { return; }

    var knop = form.querySelector('[name="add"], .add-to-cart');
    var fotoVeld = form.elements['properties[Voorbeeldfoto]'];

    wisFout(blok);

    /* Vanaf hier is het onze verantwoordelijkheid: het thema mag er niet
       overheen, ook niet als we hieronder afbreken op een fout. */
    e.preventDefault();
    e.stopImmediatePropagation();

    if (typeof form.reportValidity === 'function' && !form.reportValidity()) { return; }

    if (fotoVeld && fotoVeld.files && fotoVeld.files.length && fotoVeld.files[0].size > MAX_BYTES) {
      toonFout(blok, tekstVan(
        blok, 'tegroot',
        'Die foto is te groot (maximaal 19 MB). Kies een kleinere foto of laat hem weg.'
      ));
      return;
    }

    if (knop) { knop.classList.add('btn--loading'); knop.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        return res.text().then(function (tekst) {
          var data = null;
          try { data = JSON.parse(tekst); } catch (err) { /* geen JSON: zie hieronder */ }
          if (!res.ok || !data) {
            var e2 = new Error('mislukt');
            e2.uitleg = data && data.description ? data.description : null;
            throw e2;
          }
          return data;
        });
      })
      .then(function () {
        /* Velden leegmaken, anders staat de aanvraag er nog als de klant een
           tweede keer iets toevoegt. */
        var tekstVeld = form.elements['properties[Gewenst artikel]'];
        if (tekstVeld) { tekstVeld.value = ''; }
        if (fotoVeld) { fotoVeld.value = ''; }

        document.dispatchEvent(new CustomEvent('cart:build'));

        if (window.lfCart && typeof window.lfCart.open === 'function') {
          window.lfCart.open();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        toonFout(blok, err && err.uitleg ? err.uitleg : tekstVan(
          blok, 'mislukt',
          'Het is niet gelukt om je aanvraag toe te voegen. Probeer het opnieuw of stuur ons een bericht via WhatsApp.'
        ));
      })
      .then(function () {
        if (knop) { knop.classList.remove('btn--loading'); knop.disabled = false; }
      });
  }, true);
})();
